import { type JSX } from 'react';

export interface LandingPageHeroChicletModalDialogProps {
  readonly isOpen: boolean;
  readonly onToggle: (isOpen: boolean) => void;
}

export interface LandingPageHeroChicletModalProps {
  readonly isOpen: boolean;
  readonly onToggle: (isOpen: boolean) => void;
  readonly Dialog: (
    props: LandingPageHeroChicletModalDialogProps,
  ) => JSX.Element;
}

const LandingPageHeroChicletModal = ({
  Dialog,
  isOpen,
  onToggle,
}: LandingPageHeroChicletModalProps) => {
  return <Dialog isOpen={isOpen} onToggle={onToggle} />;
};

export default LandingPageHeroChicletModal;
